require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-bolivia-gobernanza-en-la-carretera-ixiamas-san-buenaventura.json") })
        }
      }, "path---es-mx-update-bolivia-gobernanza-en-la-carretera-ixiamas-san-buenaventura");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-bolivia-gobernanza-en-la-carretera-ixiamas-san-buenaventura!./.cache/json/es-mx-update-bolivia-gobernanza-en-la-carretera-ixiamas-san-buenaventura.json
// module id = 918
// module chunks = 231608221292675